import { BellOutlined } from "@ant-design/icons";
import { Badge, List, Popover } from "antd";
import { useSelector } from "dva";
import React from "react";
import { capitalize } from "../../utils";
import { useLang } from "../../hooks/useLang";
import ServerPaginatedList from "../server-paginated-table/server-paginated-list";
import { connect } from "dva";
import { markRead } from "../../models/profile";
import ImageLoading from "../ImageLoading";

function Notifications({ updateCount }) {
  const [lang] = useLang();
  const title = capitalize(lang("notifications"));
  const profile = useSelector((state) => state.profile.profile);

  return (
    <div style={{ marginRight: 20, display: "flex" }}>
      <Popover
        title={title}
        onOpenChange={(visible) => {
          if (visible && profile?.unread_noti_count) {
            updateCount();
          }
        }}
        content={
          <ServerPaginatedList
            url={`/notifications?userId=${profile?.id}`}
            pageSize={15}
            style={{ height: "60vh", width: 300 }}
            renderItem={(item) =>
              item && (
                <List.Item>
                  <List.Item.Meta
                    avatar={<ImageLoading image={item?.notification?.image} />}
                    title={item?.notification?.title}
                    description={item?.notification?.body}
                  />
                </List.Item>
              )
            }
          />
        }
        destroyTooltipOnHide={true}
        trigger={["click"]}
      >
        <Badge count={profile?.unread_noti_count}>
          <BellOutlined
            title={title}
            style={{ fontSize: 20, cursor: "pointer" }}
          />
        </Badge>
      </Popover>
    </div>
  );
}

export default connect(
  ({ shop }) => ({
    shop,
  }),
  {
    updateCount: markRead,
  }
)(Notifications);
